/*-----------------------------------------------------------------------------------
 * Kingsoft Office Enterprise Cloud Services.
 * Copyright (c) Kingsoft Office,All rights reserved.
 *-----------------------------------------------------------------------------------*/
import { isAdmin, isLogin, Account, Logout, superAdmin } from './constants'
import { ADMINCOMAPNYLIST } from '../company/constants'
import axios from '@src/plugins/http2'
import { getIsLogin } from '@services/index'

export default {
  [isAdmin]: async ({ commit, dispatch, rootState }) => {
    try {
      await dispatch(ADMINCOMAPNYLIST)
      const companies = rootState.company[ADMINCOMAPNYLIST]
      if (companies && companies.length) {
        commit(isAdmin, true)
      } else {
        commit(isAdmin, false)
      }
    } catch (error) {
      commit(isAdmin, false)
    }
  },
  [isLogin]: async ({ commit, dispatch }, isSkipLogin) => {
    try {
      commit(isLogin, 'logining')
      const res = await getIsLogin()
      if (res.data) {
        window._userInfo = res.data
        // 请求企业超管
        if (res.data.companyid) {
          const superAdminData = await axios.get(
            'PLUSSVR',
            `/svr/v1/companies/${res.data.companyid}/super-admin`
          )
          commit(superAdmin, superAdminData.data.name)
        }
        commit(Account, res.data)
        commit(isLogin, true)
        dispatch(isAdmin)
        return
      }
      !isSkipLogin && commit(isLogin, false) // 如果isSkipLogin为true，则跳过检查登录
    } catch (error) {
      !isSkipLogin && commit(isLogin, false) // 如果isSkipLogin为true，则跳过检查登录
    }
  },
  [Logout]: async ({ commit }) => {
    try {
      await axios.post('ACCOUNT', `/p/logout`)
      commit(isLogin, false)
    } catch (error) {
      commit(isLogin, true)
    }
  },
  async USER_GET_SUPER_ADMIN_NAME({ commit }, companyId) {
    // 渠道商途径获取超管名称
    const superAdminData = await axios.get(
      'PLUS',
      `/api/v1/channels/me/companies/${companyId}/users/super-admin`
    )
    commit(superAdmin, superAdminData.data.name)
  },
}
